import axios from 'axios';
import { ImageObjType } from '../types';
import { TABLE } from '../const';

class GateOutsService {
  add = async (props: any) => axios.post('/gate-outs', props);

  createByFilter = ({ id, containerIds }: any) =>
    axios.post(`/gate-outs/filter/${id}`, containerIds);

  getAll = async ({ params: { pageParam = 0, ...params } }: any) => {
    const res = await axios.get('/gate-outs', { params });

    return { data: res.data, totalCount: res.data.totalCount, pageParam };
  };

  getLicensePlateNumber = (props: any) => async () => {
    if (props.params.licensePlateNumber?.length < 3) delete props.params.licensePlateNumber;

    const data = await axios
      .get('/gate-outs/license-plate-number', {
        params: { ...props.params, notLoading: true, take: TABLE.PAGE_MAX_SIZE, skip: 0 },
      })
      .then((res) => res.data.data);

    return data;
  };

  loaded = ({ id, props }: any) => axios.patch(`/gate-outs/${id}/loaded`, props);

  complete = ({ id, props }: any) => axios.patch(`/gate-outs/${id}`, props);

  options = (props: any) => async () => {
    const res = await gateOutsService.getAll({
      params: { take: TABLE.PAGE_MAX_SIZE, skip: 0, notLoading: true, ...props },
    });

    const data = res.data.data.map((container: any) => ({
      ...container,
      label: container.number,
      id: container.id,
    }));

    if (props.includeGateOutLoaded) {
      return {
        containerOptions: data,
        clientCode: res.data.clientCode,
        allRequestTotalCount: res.data.allRequestTotalCount,
      };
    }

    return data;
  };

  uploadImages = (id: string, photos: ImageObjType[] = []) => {
    if (!photos.length) return true;

    const formData = new FormData();
    for (const i in photos.map((obj) => obj.file)) {
      formData.append(`images`, photos[i].file);
    }

    return axios.patch(`/gate-outs/${id}/upload-images`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  updateImages = async ({ id, photos = [] }: { id: string; photos: ImageObjType[] }) => {
    return this.uploadImages(
      id,
      photos.filter((obj) => obj.action === 'upload'),
    );
  };
}

export const gateOutsService = new GateOutsService();
